module.exports = new __parcel__URL__("blowfromtheshadows.285c5f25.png").toString();